import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 181.63 170.04' {...props}>
    <g data-name='Layer 2'>
      <path
        d='M181.24 44.28L90.82 0 .4 44.28H0V170h8V75.77h165.63V170h8V44.28zM90.82 9L163 44.28H18.61zM8 67.77v-13.9h165.63v13.9z'
        fill='undefined'
        data-name='Layer 1'
      />
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/GazebiIcon.js